<template>
  <VTableHistory
    :tableHeaders="headers"
    :items="items"
  />
</template>

<script>
import VTableHistory from '@/components/shared/content-views/VTableHistory';
import { cloneDeep } from 'lodash';

export default {
    name: 'History',
    components: {
        VTableHistory,
    },
    props: {
        history: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            data: {},
        };
    },
    computed: {
        headers() {
            return ['date', 'name', 'action'].map(header => ({
                text: this.$t(`technicalFile.closedLoop.step3.${header}`),
                value: header,
                sortable: false,
            }));
        },
    },
    watch: {
        history: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.history) };
            },
            immediate: true,
        },
    },
    created() {
        this.formatHistory();
    },
    methods: {
        // TODO make this standard for all history tables
        formatHistory() {
            this.items = this.history.map(item => ({ ...item, name: item.updatedBy, date: this.$options.filters.formatDate(item.updatedAt, 'L LT') }));
        },
        updateData() {
            this.$emit('sendData', { history: this.data });
        },
    },
};
</script>
